export const ActionTypes = {
    ADD_QUESTION: 'ADD-QUESTION',
    UPDATE_FILTER : 'UPDATE-FILTER',
    GET_SINGLE_QUESTION : 'GET-SINGLE-QUESTION',
    ADD_COMMENT : 'ADD-COMMENT',
    CONNEXION_REFUSED : 'CONNEXION_REFUSED',
    CLEAN_ERROR : 'CLEAN-ERROR',
    CLEAN_FILTER: 'CLEAN-FILTER'
}